<h1 mat-dialog-title>
  <i *ngIf="data.iconClass" class="mdi {{data.iconClass}} mr-2"></i>{{ data.title || 'Confirmation' }}
</h1>
<div mat-dialog-content>
  <p [innerHTML]="data.message"></p>
</div>
<div mat-dialog-actions>
  <button class="btn btn--primary btn--md" [mat-dialog-close]="true" tabindex="2">{{ data.okLabel || 'Ok' }}</button>
  <button class="btn btn--md" (click)="onNoClick()" tabindex="-1">{{ data.cancelLabel || 'Cancel' }}</button>
</div>
